import axios, {AxiosRequestConfig} from "axios";
import keycloakConfig, {isLoggedIn, onUpdateToken} from "../security/KeyclockConfig";

const HttpMethods = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
};

const _axios = axios.create();
const baseUrl: string | undefined = process.env.BASE_API_URL ? process.env.BASE_API_URL : "";
const restVersionPath: string | undefined = "";

const configure = () => {

    _axios.interceptors.request.use((config) => {

        if (isLoggedIn()) {
            const cb = () => {
                config.headers.Authorization = `Bearer ${keycloakConfig.token}`;
                // config.headers["Access-Control-Allow-Origin"] = "*";

                return Promise.resolve(config);
            };
            return onUpdateToken(cb);
        }
    });
};



const getBlob = (path = "") => {
    let url = baseUrl + restVersionPath + path;
    return _axios.get(url, {
        method: 'GET',
        responseType: 'blob', // important
    });
}

const get = (path = "") => {
    let url = baseUrl + restVersionPath + path;
    return _axios.get(url);
}


const put = (path = "", payload: any) => {
    let url = baseUrl + restVersionPath + path;
    return _axios.put(url, payload, {
        headers: {
            'content-type': 'application/json'
        }});
}

const post = (path = "", payload: any) => {
    let url = baseUrl + restVersionPath + path;
    return _axios.post(url, payload,{
        headers: {
            'content-type': 'application/json'
        }});
}



const postWithConfig = (path = "", payload: any,config:AxiosRequestConfig) => {
    let url = baseUrl + restVersionPath + path;
    return _axios.post(url, payload,config);
}


const deleteOne = (path = "") => {
    let url = baseUrl + restVersionPath + path;
    return _axios.delete(url);
}

const getAxios = () => {
    return axios;
}

const getAxiosClient = () => _axios;

const HttpService = {
    HttpMethods,
    configure,
    getAxiosClient,
    getBlob,
    get,
    put,
    post,
    postWithConfig,
    deleteOne,
    getAxios
};


export default HttpService;
